<template>
    <div>
        <div class="titleInvite" >
            <div style="float: left">
            <a  v-on:click="home" >
                <img src="@/assets/logoMenu.png" class="logo" />
            </a>
            </div>
        </div>
        
        <s-modal
            title="Vous avez plusieurs joueurs"
            :close="false"
            :open="openChoiceJoueur"
        >
            <div v-if="!waiting">
            Choisissez le joueur que vous voulez 
            <span v-if="participe">
                inscire
            </span>
             <span v-if="!participe">
                désincrire
            </span>
            <div v-for="joueur in listJoueurs" class="choice">
                {{joueur.nom}} {{joueur.prenom}} <br/>
                <s-button label="Inscire" theme="is-success" @onclick="participerOnePlayer(joueur.id, 1)"/>
                &nbsp;
                <s-button label="Desincrire" theme="is-danger" @onclick="participerOnePlayer(joueur.id, 0)"/>
            </div>
            </div>
            <div v-if="waiting">
                veuillez patienter un instant ...
            </div>
        </s-modal>
        <div v-if="joueur!=null" class="joueur">
             {{joueur.nom}} {{joueur.prenom}} 
             <s-button 
                v-if="listJoueurs.length>0"
                @onclick="openChoiceJoueur=true" label="Changer" icon="exchange-alt" theme="is-primary is-small"/>
        </div>
        <div v-show="error=='DATEDEPASSEE'" class="error">
            La date limite pour les 
            <span v-if="participe">inscriptions est le {{dateLimit.toLocaleString("fr-FR")}}</span>
            <span v-if="!participe">désinscriptions est le {{dateLimitUnscribe.toLocaleString("fr-FR")}}</span>
             <br/>
            Désolé, mais vous ne pouvez plus vous 
            <span v-if="participe">inscire</span>
            <span v-if="!participe">désinscire</span> à ce concours
        </div>
        <div v-show="error=='USERNOTEXIST'" class="error">
            Oups... Votre email n'est pas connu... Veuillez contactez le propriétaire du club {{club}}
        </div>
        <div v-show="error=='NOTCLUB'" class="error">
            Oups... Le club {{club}} n'est pas connu... Veuillez contactez le propriétaire du club 
        </div>
        <div v-show="error=='MEMBRENOTEXIST'"  class="error">
            Oups... Vous n'êtes pas membre du club {{club}} ... Veuillez contactez le propriétaire du club 
        </div>
        <div v-show="error=='TOURNOINOTEXIST'"  class="error">
            Oups... Le tournoi n'existe plus... Veuillez contactez le propriétaire du club 
        </div>
        <div v-show="error=='TOURNOISTART'"  class="error">
            Le tournoi a démarré ! Vous ne pouvez plus vous préinscrire...  Veuillez contactez le propriétaire du club 
        </div>
        <div v-if="tournoi!=null" class="tournoi">
            Votre club {{club}} a planifié <br/>un tournoi le {{formatDate(tournoi.date)}}  à {{tournoi.heure}}
        </div>
        <div v-if="error=='PARTICIPE' && tournoi!=null" class="participe">
            Vous êtes déjà préinscrit !<br/>
            <s-button label="ANNULER MA PREINSCRIPTION" 
                v-if="this.tournoi.options.unsubscribe" 
                theme="is-large is-danger" @onclick="participer(0)"/>
           
        </div>
        <div v-if="error=='NOTPARTICIPE' && tournoi!=null" class="notparticipe">
            Vous n'étiez pas inscrits !
            <s-button label="JE SOUHAITE Y PARTICIPER" theme="is-success" @onclick="participer(1)"/>
            
        </div>
        <div v-if="error==null && tournoi!=null && participe==1" class="participe">
            Félicitations ! <br/>
            Votre préinscription a bien été prise en compte<br/>
            Vous êtes préinscrits dans le tournoi qui se déroulera le  {{formatDate(tournoi.date)}} à {{tournoi.heure}}
            <br/>
            <s-button  v-if="this.tournoi.options.unsubscribe"  label="ANNULER MA PREINSCRIPTION" theme="is-large is-danger" @onclick="participer(0)"/>
            
            
        </div>
        <div v-if="error==null && tournoi!=null && participe==0" class="notparticipe">
            Vous ne participerez pas à ce tournoi<br/>
            <s-button label="JE SOUHAITE Y PARTICIPER" theme="is-success is-medium" @onclick="participer(1)"/>
           
        </div>
        <div v-if="user!=null" class="connect" v-show="error!='NOTCLUB'">
            <div v-if="userCurrent!=null">
                <div v-if="user.email==userCurrent.email">
                    Vous pouvez suivre les concours en direct ! <br/>
                    <s-button theme="is-primary is-medium" label="VOIR LES CONCOURS DE MON CLUB" @onclick="goConcours"/>
                </div>
                <div v-if="user.email!=userCurrent.email">
                    Oups à priori, vous êtes connecté à petanque-app.com mais pas avec le bon mail<br/>
                    <s-button theme="is-primary is-medium" label="JE VEUX ME CONNECTER A MON CLUB" @onclick="goInviteClub"/>
                </div>
            </div>
            <div v-if="userCurrent==null">
                    Vous n'êtes pas encore connecté ?<br/>
                    Faites le tout de suite !<br/>
                    Vous allez pouvoir suivre les concours de votre club en direct !!!<br/>
                    <s-button theme="is-primary is-medium" label="JE VEUX ME CONNECTER A MON CLUB" @onclick="goInviteClub"/>
            </div>
        </div>
        <div v-if="error!=null && error!='PARTICIPE' && error!='NOTPARTICIPE'" style="text-align:center">
                <s-button theme="is-warning" icon="home" label="ACCUEIL" @onclick="home"/>
        </div>
    </div>
</template>
<style scoped>
    .choice {
        margin: 5px;
    }
    .connect {
         background-color: rgb(92, 130, 255);
        color: white;
        font-size: 20px;
        font-weight: bolder;
        text-align:center;
        border-radius: 10px;
        padding: 10px;
        margin: 10px;
    }
    .participe {
        background-color: rgb(75, 160, 49);
        margin: 10px;
        text-align: center;
        color: white;
        font-size: 20px;
        border-radius: 10px;
        padding: 10px;
    }
     .notparticipe {
        background-color: rgb(160, 33, 33);
        margin: 10px;
        text-align: center;
        color: white;
        font-size: 20px;
        border-radius: 10px;
        padding: 10px;
    }
    .tournoi {
        background-color: rgb(92, 130, 255);
        color: white;
        font-size: 20px;
        font-weight: bolder;
        text-align:center;
    }
    .error {
        background-color: rgb(48, 23, 23);
        margin: 10px;
        text-align: center;
        color: white;
        font-size: 20px;
        border-radius: 10px;
        padding: 10px;
    }
    .titleInvite {
            background-color: rgb(92, 130, 255);
            font-size: 20px;
            padding: 20px;
            color: white;
            height: 120px;
        }
     .logo {
                width: 150px;
                margin-left: auto;
                margin-right: auto;
                padding-top: 5px;
        }
    .joueur {
        font-size: 22px;
        font-weight: bolder;
        background-color: rgb(92, 130, 255);
        margin-top: 5px;
        margin-top: 5px;
        padding: 5px;
        text-align: center;
        color: white;
        border: thin solid black;
    }
</style>
<script>
import firebase from "firebase"
import SModal from '../../components/SModal.vue';
export default {
  components: { SModal },
    data() {
        return {
            idClub: null,
            idTournoi: null,
            email: null,
            club: null,
            participe: null,
            error: null,
            tournoi: null,
            user: null,
            userCurrent: null,
            idJoueur : null,
            listJoueurs: [],
            openChoiceJoueur: false,
            waiting: false,
            joueur: null
        }
    },
    computed: {
        dateLimit: {
            get() {
                if (this.tournoi!=null) {
                var delaiEmail = 0;
                if (typeof(this.tournoi.options.delaiEmail)!="undefined") {
                    delaiEmail = this.tournoi.options.delaiEmail;
                }
                return this.$dateLimit(new Date(this.tournoi.date), this.tournoi.heure, delaiEmail);
                }
                else
                    return new Date();
            }
        },
        dateLimitUnscribe: {
            get() {
                if (this.tournoi!=null) {
                var delaiEmail = 0;
                if (typeof(this.tournoi.options.delaiEmailUnscribe)!="undefined") {
                    delaiEmail = this.tournoi.options.delaiEmailUnscribe;
                }
                return this.$dateLimit(new Date(this.tournoi.date), this.tournoi.heure, delaiEmail);
                }
                else
                    return new Date();
            }
        }
    },
    methods: {
        formatDate(date) {
            var options = { year: "numeric", month: "numeric", day: "numeric"};
            return (new Date(date)).toLocaleString("fr-Fr",options);
        },
        formatHeure(date) {
             var dateData = new Date(date);
                if (dateData.getMinutes()<10)
                    var minutes = "0" + dateData.getMinutes();
                else    
                    var minutes = dateData.getMinutes();
                return (dateData.getHours() + ":" + minutes)
        },
        home: function() {
          this.$router.push({name: "home"})
            .then(()=>{})
            .catch(error=>{
            });
        },
        goInviteClub: function() {
            this.$router.push({name: "invitClub", params: {id: this.idClub, email: this.email, club: this.club}})
            .then(()=>{})
            .catch(error=>{
            });
        },
        goConcours: function() {
            this.$router.push({name: "concours" , params: {id:  this.idClub}});
        },
        participerOnePlayer(idJoueur, go) {
            this.waiting = true;
            this.idJoueur = idJoueur;
            this.participer(go);
           
        },
        participer: function(go) {
            var today = {};
            today = {
                date: (new Date()).getTime(),
                heure: (new Date()).getHours()
            }
            
         
            var params =  {
                idClub: this.idClub,
                IdTournoi: this.idTournoi,
                email: this.email,
                participe: go,
                idJoueur: this.idJoueur,
                today: today            
            }
             const functions = firebase.app().functions('europe-west1');
            functions.httpsCallable("participeTournoi")(params).then(res=>{
                this.waiting = false;
                this.openChoiceJoueur = false;
                this.error = res.data.error;
               
                this.user = res.data.user;
           
                this.tournoi = res.data.tournoi;
                this.joueur = res.data.joueur;
                
                this.participe = res.data.participe;
            })
        }
    },
    mounted() {
        this.userCurrent = this.$store.getters.getUser;
        this.idClub = this.$route.params.id;
        this.club = this.$route.params.club;
        this.idTournoi = this.$route.params.idTournoi;
        this.email = this.$route.params.email;
        this.club = this.$route.params.club;
        this.participe = this.$route.params.participe;
        var today = {};
            today = {
                date: (new Date()).getTime(),
                heure: (new Date()).getHours()
            }
        var params =  {
            idClub: this.idClub,
            IdTournoi: this.idTournoi,
            email: this.email,
            participe: this.participe,
             today: today
        }
        
        const functions = firebase.app().functions('europe-west1');
        functions.httpsCallable("participeTournoi")(params).then(res=>{
                
                this.error = res.data.error;
               
                this.user = res.data.user;
               
                this.tournoi = res.data.tournoi;
               
                this.participe =  res.data.participe;
                this.joueur = res.data.joueur;
                this.listJoueurs = res.data.listJoueurs;
              
                if (this.listJoueurs.length>0 && this.error == null)
                    this.openChoiceJoueur = true;
        })
    }
}
</script>